import {createUseStyles} from "react-jss";
import React, {useState} from "react";
import {BLOCK_UNLOCKED, useProgressDispatch} from "../progress/progressContext";

const useStyles = createUseStyles({
    root: {
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: 400,
        gap: 12,
    },
    label: {
        fontSize: "14px",
        fontFamily: "Roboto, sans-serif",
        fontWeight: 500,
        color: "inherit",
        textAlign: "center",
    },
    inputGroup: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        width: "100%",
        justifyContent: "center",
        flexWrap: "wrap",
    },
    input: {
        padding: "0px 24px",
        gap: "10px",
        borderRadius: "999px",
        background: "rgba(255, 255, 255, 0.95)",
        boxShadow: "rgba(0, 0, 0, 0.3) 0px 2px 3px 0px inset, rgba(0, 0, 0, 0.075) 0px 2px 12px 0px inset",
        height: "48px",
        minWidth: "218px",
        appearance: "none",
        outline: "none",
        textAlign: "center",
        fontSize: "16px",
        fontFamily: "Roboto, sans-serif",
        lineHeight: "150%",
        border: "2px solid transparent",
        "&:focus-visible": {
            border: "2px solid #4484F1",
            outline: "2px solid #4484F1",
            outlineOffset: "2px",
        },
    },
    submitButton: {
        padding: "0 20px",
        height: "48px",
        minHeight: "44px",
        minWidth: "44px",
        borderRadius: "999px",
        background: "#3F3F3F",
        color: "#FFFFFF",
        border: "none",
        cursor: "pointer",
        fontFamily: "Roboto, sans-serif",
        fontSize: "14px",
        fontWeight: 500,
        outline: "none",
        "&:focus-visible": {
            outline: "2px solid #4484F1",
            outlineOffset: "2px",
        },
    },
    status: {
        minHeight: 24,
        fontSize: "14px",
        fontFamily: "Roboto, sans-serif",
        marginTop: 4,
        textAlign: "center",
    },
});

export const CodewordBlock = ({
    sectionId,
    containerId,
    blockId,
    secret,
    placeholder,
    label,
    id,
    onClick = null,
}) => {
    const classes = useStyles();
    const [value, setValue] = useState("");
    const [hasError, setHasError] = useState(null);
    const [statusMessage, setStatusMessage] = useState("");
    const progressDispatch = useProgressDispatch();

    const inputId = id || `codeword-input-${sectionId}-${containerId}-${blockId}`;
    const statusId = `codeword-status-${sectionId}-${containerId}-${blockId}`;

    const handleChange = event => {
        setValue(event.target.value);
    };

    const handleSubmit = event => {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        if (secret && value && secret.trim().toLowerCase() === value.trim().toLowerCase()) {
            setHasError(false);
            setStatusMessage("Riktig kodeord! Låser opp...");
            progressDispatch({
                type: BLOCK_UNLOCKED,
                payload: {
                    sectionId: sectionId,
                    containerId: containerId,
                    blockId: blockId,
                },
            });
        } else {
            setHasError(true);
            setStatusMessage("Feil kodeord. Prøv igjen.");
        }
    };

    const handleClick = () => onClick?.();

    return (
        <div className={classes.root}>
            <form onSubmit={handleSubmit} className={classes.form}>
                <label htmlFor={inputId} className={classes.label}>
                    {label || "Skriv inn kodeord for å låse opp"}
                </label>
                <div className={classes.inputGroup}>
                    <input
                        id={inputId}
                        className={classes.input}
                        type="text"
                        placeholder={placeholder || "Skriv kodeordet"}
                        autoComplete="off"
                        maxLength={20}
                        value={value}
                        aria-invalid={hasError === null ? undefined : (hasError ? "true" : "false")}
                        aria-describedby={statusId}
                        onChange={handleChange}
                        onClick={handleClick}
                    />
                    <button type="submit" className={classes.submitButton}>
                        Lås opp
                    </button>
                </div>
                <div
                    id={statusId}
                    role="status"
                    aria-live="polite"
                    className={classes.status}
                >
                    {statusMessage}
                </div>
            </form>
        </div>
    );
};

